import {prefix} from "app/config/routes/pp/_cfg";

export const routePPOrders = {
    'pp.orders':                   `${prefix}/account/orders`,
    'pp.order':  (i=':orderId') => `${prefix}/account/orders/${i}`,
}